import { Fragment } from 'react';

import PropTypes from 'prop-types';
import { getFormattedNumber } from 'utils/clickme';
import { VIEW_DATE_WITH_TIME_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import Tip, { TipPlacement } from 'bloko/blocks/drop/Tip';
import HoverTip from 'bloko/blocks/drop/Tip/HoverTip';

import useTrls from 'hooks/translation/useTrls';

import Label from 'components/Label';

import { RefundStatus } from 'store/models/invoices';

import 'components/Admin/InvoiceDetail/Payments/Payments.less';

const Refund = ({ status, amount, createdAt, user }) => {
    const trl = useTrls();

    return (
        <HoverTip
            placement={TipPlacement.Top}
            render={() => (
                <div>
                    <p>{trl('admin.Invoices.InvoicesTable.Invoice.Refund.Title')}</p>
                    <p>
                        {trl('admin.Invoices.InvoicesDetail.Invoice.Body.Refund.date')}
                        {formatDate(createdAt, VIEW_DATE_WITH_TIME_FORMAT)}
                    </p>
                    <p>
                        {trl('admin.Invoices.InvoicesDetail.Invoice.Body.Refund.status')}
                        {trl(`admin.Invoices.InvoicesTable.Invoice.Refund.${status}`)}
                    </p>
                    <p>
                        {trl('admin.Invoices.InvoicesDetail.Invoice.Body.Refund.value')}
                        {getFormattedNumber(amount)}
                    </p>
                    {user && (
                        <Fragment>
                            <p>
                                {trl('admin.Invoices.InvoicesDetail.Invoice.Body.Refund.userId')}
                                {user.id}
                            </p>
                            <p>
                                {trl('admin.Invoices.InvoicesDetail.Invoice.Body.Refund.userName')}
                                {user.name}
                            </p>
                        </Fragment>
                    )}
                </div>
            )}
            host={document.body}
            DropElement={Tip}
        >
            <span className="refund-label">
                <Label type={status === 'FINISH' ? 'refund-finish' : 'refund-new'}>{getFormattedNumber(amount)}</Label>
            </span>
        </HoverTip>
    );
};

Refund.propTypes = {
    status: PropTypes.oneOf(Object.values(RefundStatus)),
    amount: PropTypes.number,
    createdAt: PropTypes.string,
    user: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
    }),
};

export default Refund;
